import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import BootstrapTable from 'react-bootstrap-table-next';

import { InsightsOffCanvas } from '../InsightsOffCanvas';

import './InsightSettings.css';

export const PrescriptionInsightHistoryTable = (data) => {
  let tableData = [];

  function stringifyReasons(changeReasons) {
    if (changeReasons) {
      let string = '';

      changeReasons['Other signs']?.forEach((reason) => {
        string += reason + ', ';
      });
      changeReasons['Warning signs']?.forEach((reason) => {
        string += reason + ', ';
      });
      changeReasons['Good signs']?.forEach((reason) => {
        string += reason + ', ';
      });
      return string.substring(0, string.length - 2);
    } else {
      return 'No change reasons';
    }
  }

  if (data.settings) {
    for (var i = 0; i < data.settings.length; i++) {
      tableData.push({
        id: data.settings[i].id,
        created_at: moment(data.settings[i].created_at).format('DD MMM YYYY'),
        dosage: data.settings[i].settings.dosageQty
          ? data.settings[i].settings.dosageQty +
            ' ' +
            data.settings[i].settings.dosageFrequency
          : 'No dosage set',
        dosageChangeReason: data.settings[i].settings.dosageChange
          ? stringifyReasons(data.settings[i].settings.changeReasons)
          : 'No dosage changed',
        insightSetting:
          data.settings[i].settings.changeInsight ?? 'No insights needed',
        insightChangedBy: data.settings[i].created_by_firstname
          ? data.settings[i].created_by_firstname +
            ' ' +
            data.settings[i].created_by_lastname
          : 'System default',
      });
    }
  } else {
    tableData.push({
      id: Math.random(),
      created_at: '',
      dosage: '',
      insightSetting: 'No insights needed',
      insightChangedBy: '',
    });
  }

  // Table Columns
  const columns = [
    {
      dataField: 'created_at',
      text: 'Date',
      classes: 'col20',
      headerStyle: { fontWeight: 400 },
    },
    {
      dataField: 'dosage',
      text: 'Dosage',
      classes: 'col20',
      headerStyle: { fontWeight: 400 },
    },
    {
      dataField: 'dosageChangeReason',
      text: 'Dosage change reason',
      classes: 'col20',
      headerStyle: { fontWeight: 400 },
    },
    {
      dataField: 'insightSetting',
      text: 'Insight setting',
      classes: 'col20',
      headerStyle: { fontWeight: 400 },
    },
    {
      dataField: 'insightChangedBy',
      text: 'Insight changed by',
      classes: 'col20',
      headerStyle: { fontWeight: 400 },
    },
  ];

  let uKey = 0;

  return data.settings.length > 0 ? (
    <>
      <div>
        <div style={{ padding: '0px 11px 0px 11px', marginTop: '-20px' }}>
          <BootstrapTable
            bootstrap4
            keyField="id"
            wrapperClasses="table-responsive"
            id="insightTable"
            bordered={false}
            data={tableData}
            columns={columns}
            key={uKey++}
          />
        </div>
      </div>
      <InsightsOffCanvas />
    </>
  ) : (
    <></>
  );
};
